<template>
  <div class="flex flex-col">
    <el-card class="box-card  min-h-screen">
      <div class="m-auto  text-center text-3xl">
        轮播图列表
      </div>
      <div class="flex flex-row-reverse">
        <el-button type="primary" @click="goAddSlideshow"
          >添加轮播图
        </el-button>
      </div>
      <div class=" mt-6">
        <el-table :data="tableData" border style="width: 100%">
          <el-table-column fixed prop="date" label="缩略图" width="150">
            <template slot-scope="scope">
              <img
                width="40px"
                height="40px"
                :src="scope.row.siderbar_img"
                alt=""
                srcset=""
              />
            </template>
          </el-table-column>
          <el-table-column prop="siderbar_title" label="轮播标题" width="120">
          </el-table-column>

          <el-table-column prop="publish_time" label="发布时间" width="180">
          </el-table-column>
          <el-table-column label="操作" width="150">
            <template slot-scope="scope">
              <el-button
                @click="handleClick(scope.row)"
                type="text"
                size="small"
                >查看</el-button
              >

              <el-button
                type="text"
                size="small"
                @click="deleteSlideshow(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination class="mt-6"

                       @current-change="handleCurrentChange"
                       :current-page.sync="pageQuantity"
                       background
                       :page-size="pageCount"
                       layout="total, prev, pager, next"
                       :total="pagesCount">
        </el-pagination>
      </div>
    </el-card>
    <el-dialog
      :visible.sync="dialogVisible"
      width="60%"
      :before-close="handleClose">
      <img :src="imgUrl" alt="" srcset="">

    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';


export default {
  data() {
    return {
      dialogVisible: false,
      imgUrl:'',
      tableData: [ ],
      pageQuantity:1,
      pageCount:6,
      pagesCount:'',
    };
  },
  mounted() {
    this.getImg(this.pageQuantity,this.pageCount);
  },
  methods: {
    handleCurrentChange(val) {
      this.getNews(val,this.pageCount)
    },
    //获取内容
    getImg(pageQuantity,pageCount){
      axios.get(`/siderbarsIndex?pageQuantity=${pageQuantity}&pageCount=${pageCount}`).then(({data})=>{

       if(data.code != 200){
        this.$message.error(data.msg);
        return
       }

       this.$message.success(data.msg);
       this.tableData = data.data
        this.pagesCount = data.pagesCount

       })

    },
    handleClick(raw) {

      this.imgUrl = raw.siderbar_img;

      this.dialogVisible = true;
    },
    goAddSlideshow() {
      this.$router.push("/addSlideshow");
    },
    updateSlideshow() {
      this.$router.push("/updateNews");
    },
    handleClose(done) {
      this.dialogVisible = false;
    },

    deleteSlideshow(row) {
      this.$confirm("此操作将永久删除该图片, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          axios.delete(`/siderbarDelete_id/${row.siderbar_id}`).then(({data}) => {
            if (data.code!= 200) {
              this.$message.error(data.msg);
              return;
            }
            this.$message.success(data.msg);
            this.getImg();
          });

        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    }
  },


};
</script>



// WEBPACK FOOTER //
// src/views/slideshow/slideshowList.vue